import { TaggingGtmConnector } from '@afe/tagging/gtm-connector';
import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { TRACKING_EVENTS, PAGE_VIEWS } from '../enum/tracking.enum';
import { MonitoringService } from '../services/monitoring.service';
import { StorageModule } from '../utils/storage.module';
import { removeAccentsAndReplaceSpace } from '../utils/utils';

@Directive({
  selector: '[trackingClick]'
})
export class TrackingClickDirective {
  @Input('eventLabel') eventLabel: string;

  @HostListener('click') onMouseEnter() {
    this.eventLabel = removeAccentsAndReplaceSpace(this.eventLabel);
    this.monitoringService.click(this.eventLabel);
  }
  
  constructor(el: ElementRef, public monitoringService:MonitoringService) { }
}

@Directive({
  selector: '[trackingFill]'
})
export class TrackingFillDirective {
  @Input('eventLabel') eventLabel: string;

  @HostListener('blur') onMouseEnter() {
    this.monitoringService.fill(this.eventLabel);
  }

  constructor(el: ElementRef, public monitoringService:MonitoringService) { }
}


@Directive({
  selector: '[trackingSelect]'
})
export class TrackingSelectDirective {
  @Input('eventLabel') eventLabel: string;

  @HostListener('click') onMouseEnter() {
   this.monitoringService.select(this.eventLabel);
  }

  constructor(el: ElementRef, public monitoringService:MonitoringService) { }
}

@Directive({
  selector: '[trackingPage]'
})
export class TrackingPageDirective {
  @Input('eventLabel') eventLabel: string;
  
  constructor(el: ElementRef, public monitoringService:MonitoringService, public storage: StorageModule) {
    const pageView = this.storage.getPageView();
    if (pageView != this.eventLabel && this.eventLabel) {
      this.storage.setPageView(this.eventLabel);
      this.monitoringService.send(this.eventLabel);
    };
  }
}